import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { connect } from 'react-redux';

// Utils
import { closePopup } from '../components/popupPanel/popupActions';
import { getElementId } from '../../common/elements/utils/elementPropertyUtils';
import quickNotesPopupStayActivePredicate from '../workspace/header/workspaceToolsHeader/quickNotes/popup/quickNotesPopupStayActivePredicate';
import { inboxDropResultFn } from '../element/dnd/dropResultFn';
import inboxCanDrop from '../inbox/inboxCanDrop';

// Selectors
import { archiveElementsSelector } from '../workspace/sidebar/sidebarSelector';

// Actions
import * as boardService from '../element/board/boardService';

// Decorators
import ElementDropTarget from '../element/dnd/elementDropTargets/ElementDropTarget';
import elementShortcutsDecorator from '../workspace/shortcuts/clipboard/elementShortcutsDecorator';

// Components
import PopupTrigger from '../components/popupPanel/PopupTrigger';
import SidebarPopupContent from './SidebarPopupContent';

// Constants
import { DROP_TARGET_TYPES, ELEMENT_DND_TYPE } from '../../common/elements/elementConstants';
import { PopupIds, PopupSections } from '../components/popupPanel/popupConstants';
import { NATIVE_TYPES } from '../utils/dnd/dragAndDropUtils';

const mapDispatchToProps = (dispatch) => ({
    closePopupPanel: () => dispatch(closePopup(PopupIds.ARCHIVE)),
    fetchBoard: (boardId) =>
        dispatch(
            boardService.fetchBoard({
                boardId,
                excludeSelf: false,
                loadAncestors: false,
            }),
        ),
});

const getDropLocation = (props, monitor, domNode) => {
    const dropResult = inboxDropResultFn(props, monitor, domNode);

    const itemType = monitor.getItemType();

    if (itemType !== ELEMENT_DND_TYPE) return { ...dropResult };

    const { draggedElements } = monitor.getItem();
    const acceptedElementIds = draggedElements.map(getElementId);

    return {
        ...dropResult,
        acceptedElementIds,
    };
};

const dropTargetConfig = {
    drop: getDropLocation,
    canDrop: inboxCanDrop,
    acceptDropTypes: NATIVE_TYPES,
    hoverType: DROP_TARGET_TYPES.INBOX_CLOSED,
};

@connect(archiveElementsSelector, mapDispatchToProps)
@elementShortcutsDecorator
@ElementDropTarget(dropTargetConfig)
class SidebarArchivePopupUtil extends React.Component {
    componentDidMount() {
        const { rootId, fetchBoard } = this.props;
        if (!rootId) return;

        fetchBoard(rootId);
    }

    componentDidUpdate(prevProps) {
        const { closePopupPanel, childIds } = this.props;

        if (prevProps.childIds.length > 0 && childIds.length === 0) {
            closePopupPanel();
        }
    }

    render() {
        const { onPopupToggle, rootId, connectDropTarget, canDrop, isHovered, childIds } = this.props;

        if (!rootId) return null;

        return (
            <div className={classNames('ArchiveUtil', { 'can-drop': canDrop, hovered: isHovered })}>
                <div ref={connectDropTarget} className="drop-target-wrapper">
                    <PopupTrigger
                        popupId={PopupIds.ARCHIVE}
                        className="button-quick-notes header-util-button"
                        stayActivePredicate={quickNotesPopupStayActivePredicate}
                        closeSection={PopupSections.HEADER}
                        onToggle={onPopupToggle}
                    >
                        {(popupOpen) => (
                            <div className="button-content">
                                <div className="SidebarItemTitle">Archive</div>
                                <div className="SidebarItemCount"> {childIds.length > 0 ? childIds.length : ''}</div>
                            </div>
                        )}
                    </PopupTrigger>
                </div>
                <SidebarPopupContent
                    {...this.props}
                    popupId={PopupIds.ARCHIVE}
                    popupClassName="ArchivePopup"
                    listCanDropFn={inboxCanDrop}
                />
            </div>
        );
    }
}

SidebarArchivePopupUtil.propTypes = {
    tooltipEnabled: PropTypes.bool,
    popupOpen: PropTypes.bool,
    canDrop: PropTypes.bool,
    isHovered: PropTypes.bool,
    rootId: PropTypes.string,
    childIds: PropTypes.array,
    fetchBoard: PropTypes.func,
    connectDropTarget: PropTypes.func,
    onPopupToggle: PropTypes.func,
    closePopupPanel: PropTypes.func,
    element: PropTypes.object,
    elementId: PropTypes.string,
};

export default SidebarArchivePopupUtil;
